import {Component, OnInit} from '@angular/core';
import {DocumentCategory} from "../../../../domain/documentCategory";
import {DocumentCategoryService} from "../../../../service/repository/document-category.service";
import {ConfirmationService} from "primeng/primeng";
import {Router} from "@angular/router";
import {GlobalAppService} from "../../../../../core/commons/global-app.service";
import {MessageSeverity} from "../../../../../core/commons/message-severity";

@Component({
    selector: 'app-document-category',
    templateUrl: './document-category-list.component.html',
    styleUrls: ['./document-category-list.component.scss'],
    providers: [ DocumentCategoryService ]
})
export class DocumentCategoryListComponent implements OnInit {

    categories: DocumentCategory[] = [];

    constructor(private categoryService: DocumentCategoryService,
                private confirmationService: ConfirmationService,
                private router: Router,
                private appService: GlobalAppService) {
    }

    ngOnInit() {
        this.categoryService.getAll().subscribe(
            categories => this.categories = categories
        );
    }

    public createCategory() {
        this.router.navigate(['home', 'repository', "category", "new"]);
    }

    public editCategory(c : DocumentCategory) {
        this.router.navigate(['home', 'repository', "category", c.id]);
    }

    public deleteCategory(c : DocumentCategory) {
        this.confirmationService.confirm({
            message: '¿Está seguro que desea eliminar la cetegoria?',
            icon: 'fa ui-icon-delete-forever',
            accept: () => {
                this.categoryService.delete(c)
                    .switchMap(res => this.categoryService.getAll())
                    .subscribe(
                        categories => {
                            this.categories = categories;
                            this.appService.sendMsg(MessageSeverity.SUCCESS, "Exito!", "Se ha eliminado la categoria.")
                        },
                        error => {
                            this.appService.sendMsg(MessageSeverity.ERROR, "Error", "No ha sido posible eliminar el dictamen.")
                        });
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/repository/document-category/list/document-category-list.component.ts